import React from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";

/**
 * Navegación principal de escritorio. El subrayado se dibuja de izquierda a
 * derecha en hover y queda fijo en la página actual.
 */
const Nav = ({ items }) => {

	const pathname = useLocation().pathname;

	return (
		<nav className="ml-auto hidden items-center justify-center gap-6 xl:gap-9 lg:flex" aria-label="Navegación principal">
			{
				items.map((item, index) => {
					const isCurrentPage = pathname === item.href
						|| (item.isCategoryLink && pathname.indexOf("/categoria") > -1);

					return (
						<Link
							to={ item.href }
							key={ index }
							className={ `group relative inline-flex min-h-[42px] items-center text-sm tracking-[-.01em] transition-colors duration-200 ${isCurrentPage ? "font-bold text-brand-deep" : "font-medium text-[#273650]"}` }
						>
							{ item.caption }
							<span
								aria-hidden="true"
								className={ `pointer-events-none absolute inset-x-0 bottom-px h-px origin-right bg-brand transition-transform duration-200 group-hover:origin-left group-hover:scale-x-100 ${isCurrentPage ? "scale-x-100" : "scale-x-0"}` }
							></span>
						</Link>
					);
				})
			}
		</nav>
	);
};

export default Nav;
